export default __webpack_public_path__ + "static/media/left4dead2.17cebf0c.jpg";